import * as VisitorTracking from '../visitorTracking';

export function initializeEnrollNow() {
    function safeInitModal(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                return new Modal(element);
            }
            return null;  // Return null if element is not found
        }

    // find all elements with the class 'enroll-btn'
    // and add a click event listener to each
    document.querySelectorAll('.enroll-btn').forEach(button => {
        button.addEventListener('click', async function () {
            const enrollmentModal = safeInitModal('zoniModal');
            VisitorTracking.customizeSchoolEnrollment();
            enrollmentModal?.show();
        });
    });
}